import { render } from "./DocumentiFornitoriSottoprogetto.vue?vue&type=template&id=533646ad&ts=true"
import script from "./DocumentiFornitoriSottoprogetto.vue?vue&type=script&lang=ts"
export * from "./DocumentiFornitoriSottoprogetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__